import React, { useState } from 'react';
import axios from 'axios';
import baseUrl from '../../config/baseURL';
import { useParams } from 'react-router-dom';

interface Message {
  text: string;
  direction: 'inbound' | 'outbound';
}

const Chatbot: React.FC = () => {
  const { orgId } = useParams(); // Replace with dynamic orgId as needed
  const [messages, setMessages] = useState<Message[]>([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    // Add user message to thread
    const userMessage: Message = { text: input, direction: 'inbound' };
    const newMessages = [...messages, userMessage];
    setMessages(newMessages);
    setInput('');
    setLoading(true);

    try {
      // Send to backend API
      const resp = await axios.post(`${baseUrl}/core/chatbot/detect-intent/`, {
        text: input,
        thread: newMessages.slice(-10), // last 10 messages
        organization_id: orgId,
      });
      console.log('Chatbot response:', resp.data);

      const botReply: Message = {
        text: resp.data?.reply?.reply,
        direction: 'outbound',
      };

      setMessages([...newMessages, botReply]);
    } catch (err) {
      console.error(err);
      setMessages([
        ...newMessages,
        { text: 'Error processing message.', direction: 'outbound' },
      ]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: '0 auto', padding: 20 }}>
      <h2>AI Chatbot Tester</h2>
      <div
        style={{
          border: '1px solid #ccc',
          padding: 10,
          height: 400,
          overflowY: 'scroll',
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          marginBottom: 10,
        }}
      >
        {messages.map((m, idx) => (
          <div
            key={idx}
            style={{
              alignSelf: m.direction === 'inbound' ? 'flex-start' : 'flex-end',
              backgroundColor: m.direction === 'inbound' ? '#eee' : '#0084ff',
              color: m.direction === 'inbound' ? '#000' : '#fff',
              padding: '8px 12px',
              borderRadius: 12,
              maxWidth: '80%',
            }}
          >
            {m.text}
          </div>
        ))}
      </div>
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
        placeholder="Type a message..."
        style={{ width: '100%', padding: 10, fontSize: 16 }}
      />
      <button
        onClick={sendMessage}
        disabled={loading}
        style={{ marginTop: 10 }}
      >
        {loading ? 'Sending...' : 'Send'}
      </button>
    </div>
  );
};

export default Chatbot;
